import React from 'react';

import IconType from '../../../types/Icon';

const BookingPause: React.FC<IconType> = ({ color = 'currentColor', size = 24 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox={`0 0 64 64`}
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.4375 16L3.4375 44H13.6875L14 46.3125L14.25 48H60.5L59.9375 45.5625L53.9375 17.5625L53.625 16H10.4375ZM14.3125 20H50.375L55.5625 44H17.75L14.3125 20ZM11.4375 28.4375L13.125 40H8.5625L11.4375 28.4375ZM24 30V34H46V30H24Z"
				fill={color}
			/>
			<circle cx="52" cy="12" r="12" fill="#FF2C2C" />
			<path d="M48 7V17H51V7H48ZM53 7V17H56V7H53Z" fill="white" />
		</svg>
	);
};

export default BookingPause;
